/* eslint-disable react/prop-types */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var ExternalLink = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 16 : _b, _c = _a.color, color = _c === void 0 ? '#fff' : _c, _d = _a.strokeWidth, strokeWidth = _d === void 0 ? 2 : _d, _e = _a.styles, styles = _e === void 0 ? {} : _e;
    return (React.createElement("svg", { style: __assign({ width: size }, styles), viewBox: "0 0 26 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("title", null, "Group"),
        React.createElement("desc", null, "Created with Sketch."),
        React.createElement("g", { id: "Icons", stroke: "none", strokeWidth: strokeWidth, fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" },
            React.createElement("g", { id: "Group", transform: "translate(1.000000, 0.000000)", stroke: color },
                React.createElement("path", { d: "M22.5,0.75 C23.328,0.75 24,1.422 24,2.25 L24,21.75 C24,22.578 23.328,23.25 22.5,23.25 L1.5,23.25 C0.672,23.25 0,22.578 0,21.75 L0,2.25 C0,1.422 0.672,0.75 1.5,0.75 L16.5,0.75 L22.5,0.75 Z", id: "Path" }),
                React.createElement("path", { d: "M12.75,19.6666667 L12.75,4.5", id: "Path", transform: "translate(12.750000, 12.083333) rotate(50.000000) translate(-12.750000, -12.083333) " }),
                React.createElement("polyline", { id: "Path", transform: "translate(16.548304, 8.896178) rotate(50.000000) translate(-16.548304, -8.896178) ", points: "11.2983037 11.5211781 16.5483037 6.2711781 21.7983037 11.5211781" })))));
};
export default ExternalLink;
